import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceTaskCreationNotificationState = createStateReducer(initialState, {
  [events.createTaskSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "createTask",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.createKanbanTaskSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "createTask",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.createTaskFailed]: (state, { error }) => ({
    ...state,
    queue: updateNotification(
      {
        key: "createTask",
        flags: pushIf({
          ...error,
          failure: !Object.values(error).includes(true),
        }),
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceTaskCreationNotificationState };
